
import {
  Box, SimpleGrid, useColorModeValue
} from "@chakra-ui/react";
import CondicaoPagamentoForm from "./components/Form";
import PaymentFormTypeTable from "./components/Table";
import usePaymentForm from "./hooks/usePaymentForm";

export default function PaymentForm() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    condicaoPagamentos,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
    nome,
    changeInput,
    closeError,
    errorMsg,
    errorTitle,
  } = usePaymentForm();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <PaymentFormTypeTable
          add={add}
          edit={edit}
          list={condicaoPagamentos}
          deletar={showDeleteModal}
          showDelete={showDelete}
          cancelRef={cancelRef}
          closeDelete={closeDelete}
          remove={deletar}
        />
        <CondicaoPagamentoForm
          accountSelected={accountSelected}
          brandStars={brandStars}
          cancelRef={cancelRef}
          changeInput={changeInput}
          closeError={closeError}
          error={error}
          errorMsg={errorMsg}
          errorTitle={errorTitle}
          loading={loading}
          nome={nome}
          save={save}
          show={show}
          showModal={showModal}
          textColor={textColor}
        
        />

      </SimpleGrid>
    </Box>
  );
}
